import { Grid, Typography, makeStyles } from '@material-ui/core'
import { ForumRounded } from '@material-ui/icons'
import { GRAY_COLORS } from 'asterX-UIkit'

const useStyles = makeStyles(theme => ({
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #EAECF0',
    borderRadius: '12px',
    padding: '12px 15px 12px 15px',
    marginBottom: '12px',
    color: GRAY_COLORS[600]
  },
  title: {
    fontSize: '16px',
    textAlign: 'center',
    color: GRAY_COLORS[900]
  },
  subtitle: {
    fontSize: '14px',
    textAlign: 'center',
    color: GRAY_COLORS[600]
  }
}))

export const NoAssign = () => {
  const classes = useStyles()

  return (
    <Grid
      item
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ height: '100%' }}
    >
      <Grid item className={classes.icon}>
        <ForumRounded />
      </Grid>
      <Typography className={classes.title}>
        Ответственный еще не назначен
      </Typography>
      <Typography className={classes.subtitle} style={{ maxWidth: 400 }}>
        Чат будет активен после назначения специалиста технической поддержки
      </Typography>
    </Grid>
  )
}
